export enum PayFrequencyEnum {
  EveryTwoWeeks = 'EVERY_TWO_WEEKS',
  Monthly = 'MONTHLY',
  TwiceAMonth = 'TWICE_A_MONTH',
}